export var GithubEventTypeCategory;
(function (GithubEventTypeCategory) {
    GithubEventTypeCategory["Unknown"] = "GithubEventTypeCategory.unknown";
    GithubEventTypeCategory["Sourcecode"] = "GithubEventTypeCategory.sourcecode";
    GithubEventTypeCategory["Projmgmt"] = "GithubEventTypeCategory.projmgmt";
    GithubEventTypeCategory["Organization"] = "GithubEventTypeCategory.organization";
    GithubEventTypeCategory["CiCd"] = "GithubEventTypeCategory.cicd";
    GithubEventTypeCategory["Alerts"] = "GithubEventTypeCategory.alerts";
})(GithubEventTypeCategory || (GithubEventTypeCategory = {}));
export var OrbiSettingGroupName;
(function (OrbiSettingGroupName) {
    OrbiSettingGroupName["Subscription"] = "EntityMwsettingsGroup_subscription";
    OrbiSettingGroupName["Billing"] = "EntityMwsettingsGroup_billing";
    OrbiSettingGroupName["Authorization"] = "EntityMwsettingsGroup_authorization";
    OrbiSettingGroupName["GithubAuditSettings"] = "EntityMwsettingsGroup_GithubAuditChecks";
    OrbiSettingGroupName["Notifications"] = "EntityMwsettingsGroup_notifications";
    OrbiSettingGroupName["GithubReportSettings"] = "EntityMwsettingsGroup_githubreportsettings";
    OrbiSettingGroupName["GithubLiveProductionAssets"] = "EntityMwsettingsGroup_GithubLiveProductionAssets";
    OrbiSettingGroupName["GithubLiveProductionAssetsRepos"] = "EntityMwsettingsGroup_GithubLiveProductionAssetsRepos";
    OrbiSettingGroupName["GithubLiveProductionAssetsBranches"] = "EntityMwsettingsGroup_GithubLiveProductionAssetsBranches";
    OrbiSettingGroupName["Globalfilter"] = "EntityMwsettingsGroup_globalfilter";
    OrbiSettingGroupName["ImportSyncDate"] = "EntityMwsettingsGroup_importsyncdate";
    OrbiSettingGroupName["GithubOrg"] = "EntityMwsettingsGroup_GithubOrg";
    OrbiSettingGroupName["GithubAuditChecks"] = "EntityMwsettingsGroup_GithubAuditChecks";
})(OrbiSettingGroupName || (OrbiSettingGroupName = {}));
export const OrbiSettingGroupName_allvalues = [
    OrbiSettingGroupName.Billing, OrbiSettingGroupName.Authorization,
    OrbiSettingGroupName.GithubAuditSettings, OrbiSettingGroupName.Notifications, OrbiSettingGroupName.GithubReportSettings, OrbiSettingGroupName.GithubLiveProductionAssets,
    OrbiSettingGroupName.Globalfilter, OrbiSettingGroupName.ImportSyncDate,
    OrbiSettingGroupName.GithubOrg, OrbiSettingGroupName.GithubAuditChecks
];
export var OrbiSettingNvpName;
(function (OrbiSettingNvpName) {
    OrbiSettingNvpName["GithubOrg_TopicInfo"] = "EntityMwsettingsObject_OrgTopicInfo";
    OrbiSettingNvpName["GithubOrg_DefaultBranches"] = "EntityMwsettingsObject_DefaultBranches";
    OrbiSettingNvpName["GithubOrg_DefaultImportPeriod"] = "EntityMwsettingsObject_DefaultImportPeriod";
    OrbiSettingNvpName["GithubOrg_Members"] = "EntityMwsettingsObject_OrgMembers";
    OrbiSettingNvpName["Github_RepoSet"] = "EntityMwsettingsObject_GithubRepoSet";
    OrbiSettingNvpName["ImportSyncDate_parent"] = "ImportSyncDate_parent";
    OrbiSettingNvpName["ImportSyncDate_repos"] = "ImportSyncDate_repos";
    OrbiSettingNvpName["ImportSyncDate_pullrequests"] = "ImportSyncDate_pullrequests";
    OrbiSettingNvpName["ImportSyncDate_commits"] = "ImportSyncDate_commits";
    OrbiSettingNvpName["ImportSyncDate_vulns"] = "ImportSyncDate_vulns";
    OrbiSettingNvpName["ImportSyncDate_releases"] = "ImportSyncDate_releases";
    OrbiSettingNvpName["ImportSyncDate_workflows"] = "ImportSyncDate_workflows";
    OrbiSettingNvpName["ImportSyncDate_workflowruns"] = "ImportSyncDate_workflowruns";
    OrbiSettingNvpName["ImportSyncDate_repoaccesscontrol"] = "ImportSyncDate_repoaccesscontrol";
    OrbiSettingNvpName["ImportSyncDate_sourcecode"] = "ImportSyncDate_sourcecode";
    OrbiSettingNvpName["ImportSyncDate_webhookevents"] = "ImportSyncDate_webhookevents";
    OrbiSettingNvpName["ImportSyncDate_user"] = "ImportSyncDate_user";
    OrbiSettingNvpName["ImportSyncDate_useroauthinfo"] = "ImportSyncDate_useroauthinfo";
    OrbiSettingNvpName["ImportSyncDate_team"] = "ImportSyncDate_team";
    OrbiSettingNvpName["ImportSyncDate_teammember"] = "ImportSyncDate_teammember";
    OrbiSettingNvpName["ImportSyncDate_environment"] = "ImportSyncDate_environment";
    OrbiSettingNvpName["ImportSyncDate_secret"] = "ImportSyncDate_secret";
    OrbiSettingNvpName["ImportSyncDate_postprocessecret"] = "ImportSyncDate_postprocessecret";
    OrbiSettingNvpName["GithubReportSettings_reposets"] = "GithubReportSettings_reposets";
    OrbiSettingNvpName["GithubReportSettings_githubactions"] = "GithubReportSettings_githubactions";
    OrbiSettingNvpName["GithubReportSettings_repleases"] = "GithubReportSettings_releases";
    OrbiSettingNvpName["GithubReportSettings_namingconventions"] = "GithubReportSettings_namingconventions";
    OrbiSettingNvpName["GithubReportSettings_secrets"] = "GithubReportSettings_secrets";
    OrbiSettingNvpName["GithubAuditChecks_base"] = "GithubAuditChecks_base";
    OrbiSettingNvpName["GithubLiveProductionAssets_base"] = "GithubLiveProductionAssets_base";
})(OrbiSettingNvpName || (OrbiSettingNvpName = {}));
export var OrbiSettingType;
(function (OrbiSettingType) {
    OrbiSettingType["STRING"] = "OrbiSettingSTRING";
    OrbiSettingType["DATE"] = "OrbiSettingDATE";
    OrbiSettingType["INTEGER"] = "OrbiSettingInteger";
    OrbiSettingType["BOOLEAN"] = "OrbiSettingBoolean";
    OrbiSettingType["OBJECT"] = "OrbiSettingObject";
})(OrbiSettingType || (OrbiSettingType = {}));
export var OrbiRadioValues;
(function (OrbiRadioValues) {
    OrbiRadioValues["Must"] = "Orbiradio_Must";
    OrbiRadioValues["Should"] = "Orbiradio_Should";
    OrbiRadioValues["Nice"] = "Orbiradio_Nice";
    OrbiRadioValues["NA"] = "Orbiradio_NA";
})(OrbiRadioValues || (OrbiRadioValues = {}));
